<template>
  <!-- 联系人详情 -->
  <div class="contact-detail">
    <div style="background: #f5f7fa">
      <el-button
        size="mini"
        type="primary"
        @click="drawerClose"
        class="closeButton"
        >收起
        <i class="el-icon-download" style="transform: rotate(-90deg)"></i>
      </el-button>
      <!-- 公司简介 -->
      <div class="custom-company-profile">
        <!-- 第一行 -->
        <div class="custom-pro-one">
          <div style="display: flex">
            <!-- 公司名称 -->
            <el-tooltip
              class="item"
              effect="dark"
              :disabled="isShowTooltip"
              :content="contactDetail.contactName"
              placement="top-start"
            >
              <p
                ref="companyName"
                class="custom-one-title"
                :style="isList ? '' : 'marginRight: 12px'"
                @mouseover="onMouseOver('customNameStrTootip')"
              >
                <span class="text" ref="customNameStrTootip">
                  {{ contactDetail.contactName || '---' }}
                </span>
              </p>
            </el-tooltip>
            <div class="custom-one-arrow" v-if="isList">
              <el-button-group style="display: flex">
                <el-button
                  :disabled="switchData.index <= 0"
                  icon="el-icon-arrow-left"
                  style="
                    width: 16px;
                    height: 16px;
                    padding: 0;
                    margin-right: 4px;
                  "
                  @click="preCompany"
                ></el-button>
                <!--   -->
                <!-- :disabled='detailData.id == switchData.id ? true: false' -->
                <el-button
                  :disabled="
                    switchData.ids &&
                    switchData.ids.length - 1 <= switchData.index
                  "
                  icon="el-icon-arrow-right"
                  style="width: 16px; height: 16px; padding: 0"
                  @click="nextCompany"
                ></el-button>
              </el-button-group>
            </div>
          </div>
          <!-- 编辑、转为成交客户按钮 -->
          <div>
            <el-button
              type="primary"
              size="small"
              @click="editConcat()"
              style="width: 64px; font-size: 14px"
            >
              编辑
            </el-button>
            <el-button
              type=""
              size="small"
              style="font-size: 14px;border:1px solid #066EB7; color:#066EB7;"
              @click="sendEmialJump"
            >发送邮件</el-button>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 8px"></div>
      <!-- 联系人列表 -->
      <div class="custom-concat">
        <div class="left">
          <!-- 联系人信息 -->
          <div class="concact-text fine-scroll-bar">
            <div class="item">
              <div class="label">客户名称</div>
              <div
                class="value blue"
                style="cursor: pointer"
                @click="openCustomerDetail"
                v-if="contactDetail.companyName"
              >
                {{ contactDetail.companyName }}
              </div>
              <div class="value" v-else>---</div>
            </div>
            <div class="item">
              <div class="label">职务</div>
              <div class="value">{{ contactDetail.titleStr | noText }}</div>
            </div>
            <div class="item">
              <div class="label">手机</div>
              <div class="value" v-if="contactDetail.mobile">
                <span v-if="contactDetail.codeTel">{{ contactDetail.codeTelStr }}</span>
                {{ contactDetail.mobile | noText }}
              </div>
              <div class="value" v-else>---</div>
            </div>
            <div class="item">
              <div class="label">电话号码</div>
              <div class="value" v-if="contactDetail.tel">
                <span v-if="contactDetail.codeTel">{{ contactDetail.codeTelStr }}</span> {{ contactDetail.tel }}
              </div>
              <div class="value" v-else>---</div>
            </div>
            <div class="item">
              <div class="label">邮箱</div>
              <div class="value">
                <!-- <i
                  v-if="contactDetail.reboundStatus && contactDetail.reboundStatus == 10"
                  class="i"
                  :style="
                    contactDetail.reboundStatus == 10
                      ? 'backgroundColor: rgb(255, 0, 0)'
                      : ''
                  "
                ></i> -->

                <div class="tooltipItem">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                  <div slot="content">
                    <div v-if="contactDetail.emailStateType==1">
                      退订邮箱
                    </div>
                    <div v-if="contactDetail.emailStateType==2">
                      手动排除邮箱
                    </div>
                    <div v-if="contactDetail.emailStateType==3">
                      发送过程中因邮件地址不存在、邮件地址被注销、邮件地址拼写错误等原因造成的发件人所发出的信息不能被收件人正常接收
                    </div>
                    <div v-if="contactDetail.emailStateType==4">
                      由于暂时的原因，如收件人邮箱已满、收件人远程服务器暂时性故障等，导致邮件不能顺利被送达
                    </div>
                    <div v-if="contactDetail.emailStateType==0">
                      有效邮箱
                    </div>
                  </div>
                    <i
                      class="i"
                      style="cursor: pointer"
                      :class="'emailType'+contactDetail.emailStateType"
                    ></i>
                  </el-tooltip>
                </div>
                <div>
                  {{ contactDetail.email | noText }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label">微信号</div>
              <div class="value">{{ contactDetail.wechatNo | noText }}</div>
            </div>
            <div class="item">
              <div class="label">WhatsApp</div>
              <div class="value">{{ contactDetail.whatsApp | noText }}</div>
            </div>
            <div class="item">
              <div class="label">Linkedin</div>
              <div class="value blue" v-if="contactDetail.linkedinLinkShow">
                <i
                  @click="linkedinLinkShow(contactDetail.linkedinLinkShow)"
                  class="iconfont icon-yingling"
                ></i>
              </div>
              <div class="value" v-else>---</div>
            </div>
            <div class="item layout-item">
              <div class="label">备注</div>
              <div
                class="value"
                v-html="strEnterReplace(contactDetail.remark)"
              ></div>
            </div>
          </div>
          <!-- <div class="custom-concat-title">操作日志</div> -->
          <!-- 跟进日志 -->
          <!-- <div class="custom-concat-list fine-scroll-bar">
            <OperationLog 
              ref="contactListLog"
              :list="logList" 
              :totalNum="logTotalNum" 
              @getLogList="getLogList"/>
          </div> -->
          <div class="custom-concat-list fine-scroll-bar">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="height:44px;">
            <!-- 邮件发送记录 -->
            <el-tab-pane label="邮件发送记录" name="first">
              <emailSendRecord
              ref="contactListEmail"
              :list="emailSendList"
              :isLoading="isEmailLoading"
              :totalNum="emailTotalNum"
              @getEmailList="getSingleContactEmailSendRecord"/>
            </el-tab-pane>
            <!-- 操作日志 -->
            <el-tab-pane label="操作日志" name="second">
              <OperationLog 
              ref="contactListLog"
              :list="logList" 
              :totalNum="logTotalNum" 
              @getLogList="getLogList"/>
            </el-tab-pane>
          </el-tabs>
        </div>
        </div>

        <!-- ? 这里是跟进模块代码 -->
        <div style="flex: auto; background: #fff">
          <CustomerFollow
            ref="customerFollow"
            :contactName="contactDetail.contactName"
            :contactId="switchData.id"
            :contact="true"
            @anewGetDetail="anewGetDetail"
            class="CustomerFollow"
            :customerId="switchData.cid"
            :supplier-customer-user-vo-list="
              detailData.supplierCustomerUserVoList || []
            "
          ></CustomerFollow>
        </div>
      </div>
    </div>
    <!-- 新建、编辑联系人 -->
    <NewContactDialog
      ref="newcontactDialog"
      @getContactDetail="anewGetDetail"
      v-if="newcontactDialogShow"
    />
    <!-- 套餐购买 -->
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" :typeOpen="false"/>
    <!-- 发送邮件提示 -->
    <el-dialog
      title="发送提示"
      :visible.sync="dialogVisible"
      width="570px"
      :modal="true" 
      :append-to-body="true"
      custom-class="Sendreminder"
      :close-on-click-modal="false"
      >
      <div class="reason"> <i class="iconfont icon-Vector"></i> 无法发送，具体原因如下：</div>
        <div class="emailStateType">
          <!-- <span class="email" @click="openCustomerDetail"> {{ contactDetail.contactName | noText }}</span> -->
          <span>该客户邮箱存在于手动排除列表，需您手动移除后才可继续发送邮件<span class="email" @click="toStatistics(contactDetail)">去移除  ></span> </span>
        </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import NewContactDialog from './newcontactDialog'
import CustomerFollow from '@/components/customer-follow/index.vue'
import OperationLog from '@/components/custom/OperationLog'
import emailSendRecord from '@/components/custom/emailSendRecord'
import { strEnterReplace } from '@/utils/common.js'
import vipBoxDialog from "@/components/common/VIPdialog"
import {
  getContactDetail,
  getlistCustomerUserLog,
  singleContactEmailSendRecord,
  userSendEmailVerify
} from '@/utils/api/customer.js'
import { mapMutations } from 'vuex'
export default {
  components: {
    NewContactDialog,
    CustomerFollow,
    OperationLog,
    emailSendRecord,
    vipBoxDialog
  },
  props: {
    // 切换公司详情需要用到的字段
    companyData: {
      type: Object,
      default() {
        return {
          id: null, // 当前联系人id
          ids: [], // 当前页的联系人id集合
          index: 0, // 当前索引
          cid: null, // 当前客户id
          cids: [], // 当前页的客户id集合

        }
      },
    },
    isList: {
      default: true,
    },
  },
  data() {
    return {
      showDetailDialog: false,
      deleteVisible: false,
      detailData: {}, //详情数据
      switchData: {
        ids: [],
        id: null,
        cids: [],
        cid: null,
        index: 0,
      },
      logList: [], //操作日志列表
      contactDetail: {},
      linkinUrl: '',
      linkeinVisible: false,
      customerDetailShow: false,
      isShowTooltip: false,
      logTotalNum:0,
      newcontactDialogShow: false,
      activeName: "first",
      emailTotalNum:0,
      emailSendList:[],//邮件发送记录
      isEmailLoading: false,
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      dialogVisible:false
    }
  },
  methods: {
    ...mapMutations('linkedin', ['SET_VISIBLE', 'SET_LINKIN_URL']),
    strEnterReplace,
    //  跳转到手动排除
    toStatistics(item){
      if(item){
        let routeUrl =this.$router.resolve({
          name:`statistics`,
          query:{
            email:item.email,
          }
        }).href
        window.open(routeUrl, '_blank');
      }else{
        let routeUrl =this.$router.resolve({
          name:`statistics`,
          query:{
            email:this.contactDetail.email,
          }
        }).href
        window.open(routeUrl, '_blank');
      }
    },
    handleFormatDateAndTime(value) {
      if (value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    // tab选项
    handleClick(tab, event) {
      if (tab.name == 'first') {
        let currentPage = (this.$refs.contactListEmail.currentPage = 1);
        this.getSingleContactEmailSendRecord(currentPage)
      }else {
        let current = (this.$refs.contactListLog.currentPage = 1);
        this.getLogList(current);
      }
    },
    // 编辑联系人
    editConcat() {
      this.newcontactDialogShow = true
      this.$nextTick(() => {
        this.$refs.newcontactDialog.searchCustomerName()
        this.$refs.newcontactDialog.getContact(this.contactDetail, 1)
        this.$refs.newcontactDialog.dialogVisible = true
      })
    },
    // 上一个公司详情
    preCompany() {
      this.switchData.id = this.switchData.ids[this.switchData.index - 1]
      this.switchData.cid = this.switchData.cids[this.switchData.index - 1]
      this.switchData.index -= 1
      this.getContactDetailMethod()
      let current = this.$refs.contactListLog.currentPage=1
      this.getLogList(current);
      this.$emit('turnPage', false, {
        id: this.switchData.id,
        ids: [this.switchData.id],
        cid: this.switchData.cid,
        cids: [this.switchData.cid],
        index: 0,
      })
    },
    // 下一个公司详情
    nextCompany() {
      // 这里更新 this.switchData.id 为下一个，this.switchData.index + 1，然后再去请求下一条详情
      this.switchData.id = this.switchData.ids[this.switchData.index + 1]
      this.switchData.cid = this.switchData.cids[this.switchData.index + 1]
      this.switchData.index += 1
      this.getContactDetailMethod()
      let current = this.$refs.contactListLog.currentPage=1
      this.getLogList(current);
      this.$emit('turnPage', false, {
        id: this.switchData.id,
        ids: [this.switchData.id],
        cid: this.switchData.cid,
        cids: [this.switchData.cid],
        index: 0,
      })
    },

    // 操作日志
    getLogList(curPage) {
      const params = {
        id: this.switchData.id,
        customerId: this.switchData.cid,
        curPage: curPage ? curPage : this.currentPage,
        pageSize: 10,
      }
      getlistCustomerUserLog(params)
        .then((res) => {
          if (res.rspResult.bizCode == 200) {
            this.logList = res.rspPageData.list || []
            this.logTotalNum = res.rspPageData.totalNum;
          }
        })
        .catch((err) => console.error('获取操作日志失败', err))
    },
        // 获取邮件发送记录
    getSingleContactEmailSendRecord(curPage) {
      this.isLoading = true;
      const params = {
        id: this.switchData.id,
        curPage: curPage ? curPage : this.currentPage,
        pageSize: 5
      };
      singleContactEmailSendRecord(params)
        .then(res => {
          this.isLoading = false;
          if (res.rspResult.bizCode == 200) {
            this.emailSendList = res.rspPageData.list || [];
            this.emailTotalNum = res.rspPageData.totalNum;
            console.log(this.emailSendList)
          }
          this.backMsg = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.error("获取邮件发送记录", err);
        });
    },

    // 抽屉打开时触发
    handleOpen() {},

    // 跟进或编辑联系人等操作后，重新获取当前详情、日志列表、跟进列表
    anewGetDetail() {
      this.getContactDetailMethod()
      this.getLogList()
      this.$refs.customerFollow.getList()
    },

    // 当抽屉关闭时
    drawerClose() {
      this.$emit('closeDetail', true)
    },

    // 联系人详情
    async getContactDetailMethod() {
      try {
        const res = await getContactDetail({
          id: this.switchData.id,
          customerId: this.switchData.cid,
        })
        if (res.rspResult.bizCode === 200) {
          this.contactDetail = res.data
          if(!this.contactDetail.title) {
            this.contactDetail.copyTitle = this.contactDetail.title
            this.contactDetail.title = null
          } else {
            this.contactDetail.copyTitle = null
          }
        } else {
          this.contactDetail = {}
        }
      } catch (err) {
        console.error("❌ ~ file: contactDetail.vue:365 ~ getContactDetailMethod ~ err:", err)
      }
    },

    // 当客户详情关闭时，重新请求联系人详情、日志列表、跟进记录
    customerDetailAnewGetDetail() {
      this.getContactDetailMethod()
      this.getLogList()
      this.$refs.customerFollow.getList()
    },

    // 跳转linkin
    linkedinLinkShow(val) {
      this.SET_VISIBLE(true)
      this.SET_LINKIN_URL(val)
    },

    // 打开客户详情
    openCustomerDetail() {
      this.$emit('switchDetail', true, {
        id: this.contactDetail.customerId,
        ids: [this.contactDetail.customerId],
        index: 0,
      })
    },

    // 处理Tooltip溢出时才显示。
    onMouseOver(str) {
      // 内容超出，显示文字提示内容
      const tag = this.$refs[str]
      const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth
    },
    // 发送邮件
    sendEmialJump(){
      console.log(this.$route.name)
      let params={
        id:this.switchData.id
      }
      userSendEmailVerify(params).then(res=>{
        if(res.rspResult.bizCode==200){
          let routeUrl = this.$router.resolve({
            name:`contactsSendEmail`,
            query:{
              userId:this.switchData.id,
            }
          }).href
          window.open(routeUrl, '_blank');
        }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
          this.vipCode=res.rspResult.bizCode
          this.$refs.vipBoxDialog.centerDialogVisible=true
        }else if(res.rspResult.bizCode==21009){
          // this.dialogVisible=true
          this.$message({
            dangerouslyUseHTMLString: true,
            message: `<div >该客户邮箱存在于手动排除列表，需您手动移除后才可继续发送邮件<button style="color:rgb(6, 110, 183);cursor: pointer;border: none;background: none;margin-left: 12px;"  onclick ="toStatistics()">去移除  ></button> </div>`,
            type: 'error',
            // duration: 0
          });
        }else{
          this.$message.error(res.rspResult.message)
        }
      })
    }
  },
  mounted() {
    // window全局对象上定义一个这样的方法
    window.toStatistics = this.toStatistics
  },
  created() {
    // 然后拿 this.switchData.id 去请求当前详情
    this.switchData = this.companyData
    this.getContactDetailMethod(this.switchData.id)
    this.getLogList()
    this.getSingleContactEmailSendRecord()
  },
}
</script>

<style lang="scss" scoped>
.contact-detail {
  font-family: SourceHanSansCN-Regular;
  .customer-follow {
    height: calc(100vh - 87px);
  }
  .custom-company-profile {
    height: 79px;
    padding: 28px 24px 0 24px;
    background: #fff;
    box-sizing: border-box;
    .custom-pro-one {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .custom-one-title {
        // position: relative;
        color: #16181a;
        font-size: 16px;
        font-weight: 700;
        font-family: SourceHanSansCN-Bold;
        max-width: 500px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &::after {
          width: 100px;
          content: '姓名';
          position: absolute;
          top: -18px;
          left: -26px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 20px;
          color: #98a3b7;
          transform: scale(0.5, 0.5);
        }
      }
      .custom-one-arrow {
        height: 24px;
        display: flex;
        align-items: center;
        margin: 0 12px;
      }
      .custom-tags {
        .tag-button {
          width: 71px;
          height: 24px;
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
    .custom-pro-two {
      display: flex;
      height: 84px;
      line-height: 20px;
      .detail-left {
        width: 646px;
        .detail-one {
          display: flex;
          .detail-product {
            font-size: 12px;
            padding-right: 22px;
            color: #16181a;
            font-family: SourceHanSansCN-Regular;
          }

          .detail-product:last-child {
            padding-right: 0;
          }
          .detail-pro:first-child {
            margin-left: 0;
          }
        }
        .detail-pro {
          height: 12px;
          font-weight: 400;
          font-size: 12px;
          color: #4f5d78;
          margin-right: 12px;
          margin-left: 22px;
          font-family: SourceHanSansCN-Regular;
        }
        .detail-pro:first-child {
          margin-left: 0;
        }
        .detail-product {
          font-size: 12px;
          color: #16181a;
        }
      }
      .detail-right {
        display: flex;
        width: 388px;
        height: 78px;
        position: relative;
        top: 6px;
        line-height: 42px;
        border-left: 1px solid #e5e8ed;

        .detail-pro {
          height: 12px;
          font-size: 12px;
          color: #4f5d78;
          margin-bottom: 16px;
        }
        .detail-product {
          font-size: 12px;
          color: #16181a;
        }
        .detail-status {
          color: #ff7f2a;
        }
      }
    }
  }
  .closeButton {
    width: 66px;
    height: 28px;
    position: fixed;
    right: 1010px;
    top: 39px;
    box-shadow: 2px 0 4px 0 #318ced;
    border-radius: 2px;
    background-color: #318ced;
    border-color: #318ced;
  }
  .custom-concat {
    display: flex;
    padding: 0px 8px;
    .left {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 87px);
    }
    .custom-concat-title {
      padding: 0 24px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181a;
      height: 44px;
      line-height: 44px;
      border-bottom: 1px solid #f5f7fa;
      background-color: #fff;
      margin-right: 8px;
    }
    .custom-concat-list {
      padding: 20px 24px;
      background: #fff;
      margin-right: 8px;
      /* padding: 0 24px 30px 24px; */
      padding-bottom: 30px;
      /* height: calc(100vh - 215px); */
      flex: 1;
      overflow-y: auto;
      width: 588px;
      .noData {
        min-height: 200px;
        margin-top: 60px;
        text-align: center;
        img {
          width: 260px;
        }
        p {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #98a3b7;
          margin-top: 16px;
        }
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
        background-color: #f5f7fa;
      }
    }
    .concact-text {
      background-color: #fff;
      padding: 20px 24px;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 8px;
      margin-right: 8px;
      max-height: 240px;
      overflow-y: auto;
      .item {
        flex-basis: 50%;
        display: flex;
        margin-bottom: 24px;
        .label {
          width: 80px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          height: 100%;
        }
        .value {
          // flex: 1;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181a;
          width: 180px;
          display: flex;
          .tooltipItem{
            line-height: 18px;
          }
          .i {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 4px;
            // background-color: #e6a23c;
          }
        }
        .blue {
          color: #066eb7;
          i {
            cursor: pointer;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      .layout-item {
        flex-basis: 100%;
        .value {
          width: auto;
          flex: 1;
        }
      }
    }
  }
}
.icon-Vector{
  font-size: 14px;
}
// 时间线样式
::v-deep .el-timeline {
  padding-top: 12px;
  padding-left: 92px;
}
::v-deep .el-timeline-item {
  top: 4px;
  left: -8px;
}
::v-deep .el-timeline-item__timestamp.is-top {
  width: 80px;
  position: absolute;
  left: -92px;
  top: -6px;
  color: #4f5d78;
  line-height: 20px;
  text-align: right;
}
::v-deep .el-timeline-item__content {
  position: relative;
  top: -4px;
  p {
    font-weight: 400;
    font-size: 12px;
    color: #4f5d78;
  }
}
::v-deep .el-timeline-item__node {
  height: 8px;
  width: 8px;
  background: #98a3b7;
}
::v-deep .el-timeline-item__tail {
  height: 100%;
  top: 8px;
  left: 2px;
}
::v-deep .el-timeline-item:last-child {
  .el-timeline-item__tail {
    display: inline !important;
    height: 55% !important;
    top: 8px;
    left: 2px;
  }
}
::v-deep .el-input__inner {
  font-size: 12px;
}
  // 有效
  .emailType0{
    background-color: #6CD76C;
  }
  // 退订
  .emailType1{
    background-color: #A3A3A3;
  }
  // 手动排除
  .emailType2{
    background-color: #A3A3A3;
  }
  // 硬弹
  .emailType3{
    background-color: #FF6868;
  }
  // 软弹
  .emailType4{
    background-color: #FFCA56;
  }
  ::v-deep .Sendreminder{
    border-radius: 4px;
  .reason{
    color: #FAAD14;
    margin-bottom: 12px;
  }
  .el-dialog__body{
    padding: 0px 26px;
    height: 162px;
    overflow: auto;
    color: #16181a;
  }
  .el-dialog__header{
    padding: 26px ;
    padding-bottom: 20px;
    .el-dialog__title{
      font-size: 16px;
      color: #16181A;
    }
  }
  /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
  .emailStateType{
    margin-bottom: 8px;
    margin-left: 20px;
    .email{
      color: #066EB7;
      margin-right: 4px;
      cursor: pointer;
    }
  }
}
</style>
